var map = {
	"./animation.svg": "76dc",
	"./cars.svg": "c4e4",
	"./flights-animation.svg": "34e6",
	"./flights.svg": "fd58",
	"./hotels.svg": "d73e",
	"./insurance-animation.svg": "cfca",
	"./insurance.svg": "bcb3",
	"./ticket.svg": "cdc1",
	"./transfers.svg": "efa1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eee6";